import { enableProdMode } from '@angular/core';
import { bootstrapApplication } from '@angular/platform-browser';
import { actionsDispatcher, initEffects } from '@ngneat/effects';
import { enableElfProdMode } from '@ngneat/elf';
import { devTools } from '@ngneat/elf-devtools';
import { environmentProvider } from '@shared/environment-provider';
import { TrackJS } from 'trackjs';

import { AppComponent } from './app/app.component';
import { appConfig } from './app/app.config';

const isLocal =
  location.href.includes('localhost') || location.hostname === '127.0.0.1';
const env = environmentProvider.getEnvironment();

initEffects();
if (env.name === 'qa' || isLocal)
  devTools({
    name: `${env.accountManagerSite.productName} - ${isLocal ? 'localhost' : env.name}`,
    actionsDispatcher,
  });

if (!isLocal && (env.name === 'prod' || env.name === 'qa')) {
  TrackJS.install(env.trackjsConfig);
}

if (!isLocal) {
  enableProdMode();
  enableElfProdMode();
}

bootstrapApplication(AppComponent, appConfig).catch((err: unknown) => {
  console.error(err);
});
